var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",staticClass:"oct-menu-list",attrs:{"role":_vm.role,"tabindex":"-1"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }